<template>
  <div class="home"
       v-loading="loading">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box">
      <div class="currency_box">
        <div class="kc_list font24"
             @click="toCourseList">课程列表</div>
        <div class="top_nav_list">
          <div class="top_nav_item"
               v-for="(item,index) in breadcrumbList"
               :key="index">{{item.name}}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="curriculum_top_box">
        <div class="currency_box from_flex">
          <!-- 课程 -->
          <div class="kc">
            <el-image width="450px"
                      height="250px"
                      style="width:450px;height:250px;"
                      :src="courseData.coverPicture"></el-image>
          </div>
          <div class="form_content">
            <div class="curriculum_title font24">{{courseData.courseName}}</div>
            <div class="curriculum_fu_title font14">{{courseData.briefIntroduction}}</div>
            <div class="curriculum_price font18 mainColor"> <span>价格</span> ￥{{courseData.price}} </div>
            <div class="curriculum_label font14"
                 v-if="courseData.ifVipFree == 1">零售视界个人会员免费学习</div>
            <div class="curriculum_ul">
              <div v-if="courseData.totalSpan && courseData.totalSpan>0"
                   class="curriculum_li">
                <i class="el-icon-time"></i>
                {{convertTime(courseData.totalSpan)}}
              </div>
              <div class="curriculum_li">
                <div v-if="courseData.studyCount && courseData.studyCount>0">
                  <i class="el-icon-user"></i>
                  学习人数:{{courseData.studyCount}}
                </div>
              </div>
              <div class="curriculum_li">
                <i class="el-icon-set-up"></i>
                课后绑定考试
              </div>
              <div class="curriculum_li">
                <i class="el-icon-paperclip"></i>
                配套思维导图
              </div>
            </div>
            <div class="btn">
              <el-button class="mainBgColor"
                         style="color:#fff"
                         v-if="courseData.onlineCourseType == '2'"
                         type="danger"
                         @click="link(1)">会员免费学</el-button>
              <el-button class="mainBgColor"
                         style="color:#fff"
                         v-if="courseData.onlineCourseType == '1' && courseData.ifVipFree == '1'"
                         type="danger"
                         @click="link(3)">个人会员免费学</el-button>
              <el-button class="mainBgColor"
                         style="color:#fff"
                         v-if="courseData.onlineCourseType == '1' && courseData.ifVipFree == '1'"
                         type="danger"
                         @click="link(4)">企业会员免费学</el-button>
              <el-button type="danger"
                         @click="link(2)">下载APP单独购买</el-button>
            </div>

          </div>
        </div>
      </div>
      <!-- 课程详情 -->
      <div class="curriculum_details">
        <div class="currency_boxs">
          <el-tabs :tab-position="tabPosition"
                   style="min-height: 300px;width: 100%;">
            <el-tab-pane label="课程简介">
              <div class="detailedIntroduction"
                   v-html="courseData.detailedIntroduction"></div>
            </el-tab-pane>
            <el-tab-pane label="课程目录">
              <!-- 内容模式 -->
              <div v-if="courseData.onlyContain == 'onlyContent'">
                <div class="kcItem"
                     v-for="(item,index) in  courseData.courseContentEntities"
                     :key="index">
                  <!-- <div class="top flexStart">
                    <div class="left font14"
                         style="flex:1">{{item.name}}</div>
                  </div> -->
                  <div @mouseenter="mouseover(index +'y')"
                       @click="contentClick(item,index+'y')"
                       class="flexStart bottomItem">
                    <div class="left font14"
                         style="flex:1">
                      <div class="label font14">{{item.type | resourceType}}</div>
                      {{item.contentName}}
                    </div>
                    <div class="right sk"
                         v-if="item.ifFreeLook== 1">可试看</div>
                    <div v-else
                         class="right font14">
                      <i class="el-icon-lock"></i>
                      <span class="r">需购买</span> <span class="r"
                            v-if="(item.duration&&item.duration>=1)"> {{convertTime(item.duration)}}</span> <span style="margin-left:10px">{{item.clickCount}}次学习</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="courseData.onlyContain == 'onlyChapter'">
                <div class="kcItem"
                     v-for="(item,index) in  courseData.courseChapterEntities"
                     :key="index">
                  <div class="top flexStart">
                    <div class="left font14"
                         style="flex:1">{{item.name}}</div>
                  </div>
                  <div v-for="(x,y) in item.chapterContent"
                       :key="y +'x'"
                       @mouseenter="mouseover(y +'x')"
                       @click="contentClick(x,y+'x')"
                       class="flexStart bottomItem">
                    <div class="left font14"
                         style="flex:1">
                      <div class="label font14">{{x.type | resourceType}}</div>
                      {{x.contentName}}
                    </div>
                    <div class="right sk"
                         v-if="x.ifFreeLook== 1">可试看</div>
                    <div v-else
                         class="right font14"> <span class="r">需购买</span> <span class="r"
                            v-if="(x.duration&&x.duration>=1)"> {{convertTime(x.duration)}}</span> <span style="margin-left:10px">{{x.clickCount}}次学习</span> </div>

                  </div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="考试作业">
              <div v-if="courseData.examList && courseData.examList.length!=0">
                <div class="kcItem">
                  <div class="top flexStart">
                    <div class="left font14"
                         style="flex:1">考试</div>
                  </div>
                  <div v-for="(item,index) in courseData.examList"
                       :key="index +'index'"
                       class="flexStart bottomItem">
                    <div class="left font14"
                         style="flex:1">
                      {{item.contentName}}
                      <div class="label font12"
                           style="padding:2px 5px">{{item.score}}分</div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="courseData.examList && courseData.taskList.length!=0">
                <div class="kcItem">
                  <div class="top flexStart">
                    <div class="left font14"
                         style="flex:1">作业</div>
                  </div>
                  <div v-for="(item,index) in courseData.taskList"
                       :key="index +'index'"
                       class="flexStart bottomItem">
                    <div class="left font14"
                         style="flex:1">
                      {{item.contentName}}
                    </div>
                  </div>
                </div>
              </div>
              <el-empty v-if="courseData.examList && courseData.examList.length == 0 && courseData.taskList && courseData.taskList.length == 0"
                        description="该课程暂未绑定考试作业"></el-empty>
            </el-tab-pane>
            <el-tab-pane label="思维导图">
              <el-image v-if="courseData.mindMap && courseData.mindMap!=''"
                        style="min-height:200px"
                        :src="courseData.mindMap"></el-image>
              <el-empty v-else
                        style="width: 100%;"
                        description="该课程暂无思维导图"></el-empty>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <videoModal v-if="videoShow"
                ref="videoModal"
                @close="closeModal"></videoModal>
  </div>
</template>

<script>
import videoModal from '@/components/video/videoModal.vue'
import curTitle from '@/components/home/cur_title.vue'
import curriculumItem from '@/components/OnlineBusinessSchool/curriculum_item.vue'
import { courseInfo } from '@/api/api.js'
export default {
  components: { curTitle, curriculumItem, videoModal },
  data () {
    return {
      videoShow: false,
      activeIndex: -1,
      loading: false,
      courseId: '',
      url: 'https://img0.baidu.com/it/u=410476708,2625048454&fm=253&fmt=auto&app=120&f=JPEG?w=1280&h=800',
      breadcrumbList: [
        { name: '课程详情' }
      ],
      list: [
        { title: '时长：6小时54分' }, { title: '课后绑定考试' }, { title: '配套思维导图' }
      ],
      tabPosition: 'top',
      form: { name: '' },
      courseData: {}
    }
  },
  created () {
    this.init()
  },
  filters: {
    resourceType (val) {
      let text = "";
      switch (val) {
        case 'audio':
          text = '音频';
          break;
        case 'video':
          text = '视频';
          break;
        case 'image':
          text = '图片';
          break;
        case 'form':
          text = '表单';
          break;
      }
      return text;
    }
  },
  methods: {
    link (type) {
      if (type == 1) {
        this.$router.push('/Card?type=cur&index=1')
      } else if (type == 3) {
        this.$router.push('/Card?type=cur&index=2')
      } else if (type == 4) {
        this.$router.push('/Card?type=cur')
      } else {
        this.$router.push('/download')
      }
    },
    init () {
      if (this.$route.query.courseId) {
        this.courseId = this.$route.query.courseId
        this.getInfo()
      }
    },
    convertTime (span) {
      if (span == null) {
        return '0秒'
      }
      let result = parseInt(span);
      // let h = Math.floor(result / 3600) < 10 ? '0' + Math.floor(result / 3600) : Math.floor(result / 3600);
      // let m = Math.floor((result / 60 % 60)) < 10 ? '0' + Math.floor((result / 60 % 60)) : Math.floor((result / 60 % 60));
      // let s = Math.floor((result % 60)) < 10 ? '0' + Math.floor((result % 60)) : Math.floor((result % 60));

      let h = Math.floor(result / 3600);
      let m = Math.floor((result / 60 % 60));
      let s = Math.floor((result % 60));
      let res = '';
      if (h != '0') res += `${h}小时`;
      if (m != '0') res += `${m}分`;
      res += `${s}秒`;
      return res;
    },
    async getInfo () {  //课程详情
      this.loading = true;
      const res = await courseInfo(this.courseId)
      if (res && res.code == 401) {
        this.$refs.topNav.login()
        return
      }
      const regex = new RegExp('<img', 'gi');
      res.data.detailedIntroduction = res.data.detailedIntroduction.replace(regex, `<img style="width: 100%;"`);

      this.courseData = res.data;
      this.loading = false;
    },
    mouseover (index) {
      this.activeIndex = index;
    },
    contentClick (item, index) {
      if (index == this.activeIndex && item.ifFreeLook == 1) {
        this.videoShow = true;
        let items = { ...{ courseName: this.courseData.courseName, price: this.courseData.price, onlineCourseType: this.courseData.onlineCourseType, ifVipFree: this.courseData.ifVipFree }, ...item }
        console.log(items)
        this.$nextTick(() => {
          this.$refs.videoModal.init(items, 'content')
        })

      }
    },
    closeModal () {
      this.videoShow = false;
    },
    toCourseList () {
      this.$router.push('/Screen')
    }
  }
}
</script>

<style lang="less" scoped>
.home {
  position: relative;
  background-color: #f5f5f5;
  min-height: 100vh;
  // padding-top: 30px;
  .box {
    min-width: 1200px;
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #de1f26;
    color: #fff;
    .kc_list {
      font-weight: bold;
      padding-right: 18px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    .top_nav_list {
      flex: 1;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      .top_nav_item {
        margin-right: 15px;
      }
    }
  }
  .curriculum_top_box {
    // margin: 20px 0 0 0;
    min-width: 1200px;
    background-color: #fff;
    // height: 500px;
    padding: 50px 0 40px 0;
    box-sizing: border-box;
    .from_flex {
      display: flex;
      align-items: flex-start;
      height: 100%;
      .kc {
        width: 450px;
        height: 250px;
      }
      .form_content {
        flex: 1;
        margin-left: 24px;
        div {
          margin-bottom: 15px;
        }
        .curriculum_title {
          color: #333;
        }
        .curriculum_fu_title {
          color: #666;
        }
        .curriculum_price {
          font-family: 'bb';
        }
        .curriculum_label {
          margin-left: 5px;
          display: inline-block;
          padding: 3px 12px;
          box-sizing: border-box;
          background-color: #ffeced;
          border-radius: 16px;
        }
        .curriculum_ul {
          display: flex;
          color: #666;
          .curriculum_li {
            margin-right: 20px;
          }
        }
      }
    }
  }
  .curriculum_details {
    margin-top: 20px;
    min-width: 1200px;
    background-color: #fff;
    .detailedIntroduction {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .kcItem {
      margin: 2px 0;
      // margin-bottom: 10px;
      .bottomItem:hover {
        background-color: #ffeced;
        cursor: pointer;
      }
      .bottomItem {
        padding: 10px 20px;
        box-sizing: border-box;
        color: #666666;
        .sk {
          color: #de1f26;
          font-size: 14px;
        }
        .left {
          .label {
            display: inline-block;
            padding: 4px 10px;
            box-sizing: border-box;
            background-color: #de1f26;
            color: #fff;
          }
        }
        .right {
          .r {
            padding: 0 10px;
            border-right: 1px solid #e5e5e5;
          }
        }
      }
      .top {
        background-color: #f6f6f6;
        padding: 10px 20px;
        box-sizing: border-box;
        .left {
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
}
</style>
